export const sectionToCategoryMap: { [key: string]: string } = {
  index: 'main_page',
  sale: 'main_sale',
  rent: 'main_rent',
  'new-buildings': 'main_newobject',
  commercial: 'main_commercial',
  'daily-rent': 'main_daily',
  userArea: 'LK_main_menu',
};
